import { BaseApiClient } from './base-client';

/**
 * Composer API - методы для работы с прикрепленными файлами в композерах
 */
export class ComposerApi extends BaseApiClient {
  
  // ===== CHAT COMPOSER ATTACHMENTS =====
  
  /**
   * Сохранить прикрепленный файл в композере (для синхронизации между устройствами)
   */
  async saveChatComposerAttachment(attachment: {
    sessionId?: string | null;
    fileName: string;
    fileType: string;
    mimeType: string;
    fileSize?: number;
    s3Key: string;
    s3Url: string;
    position?: number;
    thumbnailUrl?: string;
    thumbnailS3Key?: string;
    trimStart?: number | null;
    trimEnd?: number | null;
  }): Promise<any> {
    const response = await this.client.post('/api/chat/composer-attachments', attachment);
    return response.data;
  }

  /**
   * Получить все прикрепленные файлы композера
   */
  async getChatComposerAttachments(sessionId?: string | null): Promise<any> {
    const url = sessionId 
      ? `/api/chat/composer-attachments?sessionId=${sessionId}`
      : '/api/chat/composer-attachments';
    const response = await this.client.get(url);
    return response.data;
  }

  /**
   * Удалить конкретный прикрепленный файл
   */
  async deleteChatComposerAttachment(attachmentId: string): Promise<any> {
    const response = await this.client.delete(`/api/chat/composer-attachments/${attachmentId}`);
    return response.data;
  }

  /**
   * Очистить все прикрепленные файлы (вызывается при отправке сообщения)
   */
  async clearChatComposerAttachments(sessionId?: string | null): Promise<any> {
    const url = sessionId 
      ? `/api/chat/composer-attachments?sessionId=${sessionId}`
      : '/api/chat/composer-attachments';
    const response = await this.client.delete(url);
    return response.data;
  }

  // ===== IMAGE COMPOSER ATTACHMENTS =====
  
  /**
   * Сохранить прикрепленный файл в image composer (для синхронизации между устройствами)
   */
  async saveImageComposerAttachment(attachment: {
    fileName: string;
    fileType: string;
    mimeType: string;
    fileSize?: number;
    s3Key: string;
    s3Url: string;
    fromGallery?: boolean;
    position?: number;
  }): Promise<any> {
    const response = await this.client.post('/api/images/composer-attachments', attachment);
    return response.data;
  }

  /**
   * Получить все прикрепленные файлы image composer
   */
  async getImageComposerAttachments(): Promise<any> {
    const response = await this.client.get('/api/images/composer-attachments');
    return response.data;
  }

  /**
   * Обновить порядок прикрепленных файлов image composer
   */
  async updateImageComposerPositions(positions: { id: string; position: number }[]): Promise<any> {
    const response = await this.client.patch('/api/images/composer-attachments', { positions });
    return response.data;
  }

  /**
   * Удалить конкретный прикрепленный файл
   */
  async deleteImageComposerAttachment(attachmentId: string): Promise<any> {
    const response = await this.client.delete(`/api/images/composer-attachments/${attachmentId}`);
    return response.data;
  }

  /**
   * Очистить все прикрепленные файлы (вызывается при отправке/сбросе)
   */
  async clearImageComposerAttachments(): Promise<any> {
    const response = await this.client.delete('/api/images/composer-attachments');
    return response.data;
  }

  // ===== VIDEO COMPOSER ATTACHMENTS =====
  
  /**
   * Сохранить прикрепленный файл в video composer (для синхронизации между устройствами)
   */
  async saveVideoComposerAttachment(attachment: {
    fileName: string;
    fileType: string;
    mimeType: string;
    fileSize?: number;
    s3Key: string;
    s3Url: string;
    fromGallery?: boolean;
    position?: number;
    provider?: string;
    model?: string;
    duration?: number;
    trimStart?: number;
    trimEnd?: number;
  }): Promise<any> {
    const response = await this.client.post('/api/video/composer-attachments', attachment);
    return response.data;
  }

  /**
   * Получить все прикрепленные файлы video composer
   */
  async getVideoComposerAttachments(provider?: string, model?: string): Promise<any> {
    const params = new URLSearchParams();
    if (provider) params.append('provider', provider);
    if (model) params.append('model', model);
    const queryString = params.toString();
    const url = queryString ? `/api/video/composer-attachments?${queryString}` : '/api/video/composer-attachments';
    const response = await this.client.get(url);
    return response.data;
  }

  /**
   * Удалить конкретный прикрепленный файл
   */
  async deleteVideoComposerAttachment(attachmentId: string): Promise<any> {
    const response = await this.client.delete(`/api/video/composer-attachments/${attachmentId}`);
    return response.data;
  }

  /**
   * Очистить все прикрепленные файлы (вызывается при отправке/сбросе)
   */
  async clearVideoComposerAttachments(provider?: string, model?: string): Promise<any> {
    const params = new URLSearchParams();
    if (provider) params.append('provider', provider);
    if (model) params.append('model', model);
    const queryString = params.toString();
    const url = queryString ? `/api/video/composer-attachments?${queryString}` : '/api/video/composer-attachments';
    const response = await this.client.delete(url);
    return response.data;
  }
}

